import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const languages = ['en', 'hi', 'es', 'pt'] as const;
const namespaces = ['general', 'user_config', 'clinic_config',
  'registration_lang', 'registration_patient_details', 'medicalHistory_config', 'medicalHistorySummary_config', 'hpi_config',
  'cycleOverview_config','investigation_config','examination_config', 'treatmentPlan_config','surgery_config', 
  'outcome_config' , 'documents_config', 'stimulation_config', 'oocyte_grading','culture_config', 'cryo_storage_oocyte',
  'cryo_storage_embryo', 'cryo_storage_sperm', 'material_information','cryoThawing_config' , 'pgt_config', 'patientList_config',
  'andrology_config', 'MIS_report_config', 'sidebar_config', 'topbar_config', 'dashboard_config', 'appointment_form', 'calendar' , 
  
  'aiGrading_config', 'consent_config', 'cima', 'login', 'stock_config', 'stockTransfer_config', 'Packagebilling', 'material_consumption', 
  
  'purchase_order', 'purchase_requisition', 'grn_return', 'stock_adjustment_config', 'billing_config','receive_return', 'expired_return', 'grn_config','invoice_gallery', 'rfid_config', 'issue_return', 'sales_return', 'return_config', 'inventory_approval_config'] as const;


type Language = typeof languages[number];
type Namespace = typeof namespaces[number];
type NamespaceResource = Record<string, string>;
type LanguageResource = Record<Namespace, NamespaceResource>;
type TranslationResources = Record<Language, LanguageResource>;

async function loadResources(): Promise<TranslationResources> {
  const resources: Partial<Record<Language, Partial<LanguageResource>>> = {};

  for (const lang of languages) {
    resources[lang] = {};

    for (const ns of namespaces) {
      try {
        const module = await import(`../locales/${lang}/${ns}.json`);
        resources[lang]![ns] = module.default as NamespaceResource;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`⚠️ Missing translation file: ../locales/${lang}/${ns}.json`, e);
      }
    }
  }

  return resources as TranslationResources;
}

(async () => {
  const resources = await loadResources();
  
  // Get saved language from localStorage, fallback to 'en'
  const savedLanguage = localStorage.getItem('language') || 'en';

  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      lng: savedLanguage,
      fallbackLng: 'en',
      ns: [...namespaces],
      defaultNS: 'common',
      interpolation: {
        escapeValue: false
      }
    });
})();

export default i18n;
